import React, { lazy, Suspense } from 'react';
import ComponentButton from './componentButton.js';
import ComponentLoginButton from './componentLoginButton.js';

const WelcomeCard = lazy(() => import('@boschebike/ebds-react/dist-esm/components/WelcomeCard.js'));

/**
 * @typedef {import('../../App.d.ts').WelcomeCardProps} WelcomeCardProps
 */
/**
 * @param {WelcomeCardProps} props
 */
const InternalWelcomeCardButtonComponent = (props) => {
  if (!props.button) {
    return null;
  }

  // @ts-ignore
  const type = props?.button?.type ?? props?.button?.sys?.contentType?.sys?.id;
  if (type === 'componentLoginButton') {
    // @ts-ignore
    return <ComponentLoginButton {...props.button.fields} />;
  }
  // @ts-ignore
  return <ComponentButton {...props.button.fields} />;
};

/**
 * @param {WelcomeCardProps} props
 */
export default (props) => {
  return (
    <Suspense fallback={null}>
      <WelcomeCard
        data-testid="welcome-card"
        headline={props.headline}
        subheadline={props.subheadline}
        description={<p>{props.description}</p>}
        additionalMarginTop={props.additionalMarginTop}
        button={<InternalWelcomeCardButtonComponent {...props} />}
      />
    </Suspense>
  );
};
